<script>
export default {
  name: 'OrganogramaRight',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/bold/data-2">
      <g id="data-2">
        <path
          id="Vector"
          d="M7.65405 8.33203H4.65405C3.55405 8.33203 2.65405 7.43203 2.65405 6.33203V4.33203C2.65405 3.23203 3.55405 2.33203 4.65405 2.33203H7.65405C8.75405 2.33203 9.65405 3.23203 9.65405 4.33203V6.33203C9.65405 7.43203 8.75405 8.33203 7.65405 8.33203Z"
          :fill="color"
        />
        <path
          id="Vector_2"
          d="M21.4541 7.33203H17.8541C17.1941 7.33203 16.6541 6.79203 16.6541 6.13203V4.53203C16.6541 3.87203 17.1941 3.33203 17.8541 3.33203H21.4541C22.1141 3.33203 22.6541 3.87203 22.6541 4.53203V6.13203C22.6541 6.79203 22.1141 7.33203 21.4541 7.33203Z"
          :fill="color"
        />
        <path
          id="Vector_3"
          d="M21.4541 14.832H17.8541C17.1941 14.832 16.6541 14.292 16.6541 13.632V12.032C16.6541 11.372 17.1941 10.832 17.8541 10.832H21.4541C22.1141 10.832 22.6541 11.372 22.6541 12.032V13.632C22.6541 14.292 22.1141 14.832 21.4541 14.832Z"
          :fill="color"
        />
        <path
          id="Vector_4"
          opacity="0.96"
          d="M16.6541 13.582C17.0641 13.582 17.4041 13.242 17.4041 12.832C17.4041 12.422 17.0641 12.082 16.6541 12.082H13.9041V6.08203H16.6541C17.0641 6.08203 17.4041 5.74203 17.4041 5.33203C17.4041 4.92203 17.0641 4.58203 16.6541 4.58203H9.65405C9.24405 4.58203 8.90405 4.92203 8.90405 5.33203C8.90405 5.74203 9.24405 6.08203 9.65405 6.08203H12.4041V18.332C12.4041 19.852 13.6341 21.082 15.1541 21.082H16.6541C17.0641 21.082 17.4041 20.742 17.4041 20.332C17.4041 19.922 17.0641 19.582 16.6541 19.582H15.1541C14.4641 19.582 13.9041 19.022 13.9041 18.332V13.582H16.6541Z"
          :fill="color"
        />
        <path
          id="Vector_5"
          d="M21.4541 22.332H17.8541C17.1941 22.332 16.6541 21.792 16.6541 21.132V19.532C16.6541 18.872 17.1941 18.332 17.8541 18.332H21.4541C22.1141 18.332 22.6541 18.872 22.6541 19.532V21.132C22.6541 21.792 22.1141 22.332 21.4541 22.332Z"
          :fill="color"
        />
      </g>
    </g>
  </svg>
</template>
